import React, { useEffect, useRef, useState } from 'react';
import { INTERACTIVE_ANALYTICS_CONVERSATIONAL_AGENTS } from '../../../../content/enterpriseMessaging';
import HrDomainChatVisual from './HrDomainChatVisual';
import { PBISection } from './PBIContent';

export default function ConversationalAgentsSection() {
  const copy = INTERACTIVE_ANALYTICS_CONVERSATIONAL_AGENTS;
  const copyRef = useRef(null);
  const [panelHeight, setPanelHeight] = useState(null);

  useEffect(() => {
    const el = copyRef.current;
    if (!el) return undefined;

    const measure = () => {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        setPanelHeight(el.offsetHeight);
      } else {
        setPanelHeight(null);
      }
    };

    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    window.addEventListener('resize', measure);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);

  return (
    <PBISection accent="semantic" id="conversational-agents" tight>
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-start">
        <div ref={copyRef} className="lg:order-1">
          <p className="eyebrow">{copy.eyebrow}</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">
            {copy.title}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-ink-600">{copy.body}</p>
          <ul className="mt-6 space-y-3">
            {copy.points.map((point) => (
              <li key={point.title} className="border-l-2 border-l-brand-400 pl-4">
                <p className="text-sm font-semibold text-ink-900">{point.title}</p>
                <p className="mt-1 text-sm text-ink-600 leading-relaxed">{point.body}</p>
              </li>
            ))}
          </ul>
        </div>
        <div
          className="lg:order-2 h-[340px] sm:h-[360px] lg:h-auto lg:overflow-hidden"
          style={panelHeight ? { height: panelHeight } : undefined}
        >
          <HrDomainChatVisual />
        </div>
      </div>
    </PBISection>
  );
}
